export default __webpack_public_path__ + "static/media/driver.4458c482.jpg";